import React from 'react';
import FeatureTile from '../FeatureTile';
import { useTileData } from '../../../hooks/useTileData';
import { getGoogleAdsKpis } from '../../../api';
import { fmtCurrency, fmtNumber, fmtRatio } from '../../shared/format';

const Icon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
  </svg>
);

export default function GoogleAdsTile({ clientId, rangeStart, rangeEnd }) {
  const { data, loading, error } = useTileData(
    async () => {
      const resp = await getGoogleAdsKpis(clientId, rangeStart, rangeEnd);
      return resp?.data ?? null;
    },
    [clientId, rangeStart, rangeEnd],
    Boolean(clientId && rangeStart && rangeEnd),
  );

  const primary = data ? {
    value: fmtRatio(data.roas ?? 0),
    label: 'Return on ad spend',
    subtitle: 'Revenue per $1 spent',
  } : null;
  const secondary = data ? [
    { value: fmtCurrency(data.spend ?? 0), label: 'Spend' },
    { value: fmtNumber(data.tier1_bookings ?? 0, true), label: 'Bookings' },
  ] : [];

  return (
    <FeatureTile
      title="Google Ads"
      icon={<Icon />}
      color="red"
      primary={primary}
      secondary={secondary}
      ctaLabel="Open"
      ctaTo="/google-ads"
      loading={loading}
      error={error}
    />
  );
}
